import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("sd_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const img = (u) => (!u ? null : u.startsWith("/api") ? `${BACKEND}${u}` : u);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0] || ""}: ${x.msg}`).join(", ");
  return d || e?.message || "Something went wrong";
};

export const viewerId = () => {
  let v = localStorage.getItem("sd_vid");
  if (!v) {
    v = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("sd_vid", v);
  }
  return v;
};

export const downloadCsv = async (name) => {
  const r = await api.get(`/admin/reports/${name}`, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${name}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};
